import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Alert, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Blog.css';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get('https://madhusewingmachines.com/api/blogs');
      if (response.data.success) {
        setBlogs(response.data.blogs || []);
      }
    } catch (err) {
      console.error('Error fetching blogs:', err);
      setError('Failed to load blog posts');
    } finally {
      setLoading(false);
    }
  };

  const handleBlogClick = (blogId) => {
    navigate(`/blog/${blogId}`);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      return new Date(dateString).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });
    } catch {
      return '';
    }
  };

  const getExcerpt = (text, length = 120) => {
    if (!text) return '';
    const plain = String(text).replace(/<[^>]*>/g, '');
    return plain.length > length ? `${plain.slice(0, length).trim()}...` : plain;
  };

  if (loading) {
    return (
      <Container className="text-center py-5" style={{ marginTop: '100px' }}>
        <Spinner animation="border" />
        <p className="mt-3">Loading blog posts...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container style={{ marginTop: '100px' }}>
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  return (
    <Container className="blog-container" style={{ marginTop: '100px', marginBottom: '50px' }}>
      <h2 className="text-center mb-2">Our Blog</h2>
      <p className="text-center text-muted mb-4">
        Tips, guides and news on sewing &amp; embroidery machines
      </p>

      {blogs.length === 0 ? (
        <Alert variant="info" className="text-center">
          No blog posts available at the moment.
        </Alert>
      ) : (
        <Row>
          {blogs.map((blog) => (
            <Col key={blog._id} xs={12} sm={6} md={4} className="mb-4">
              <Card
                className="blog-card h-100 shadow-sm"
                onClick={() => handleBlogClick(blog._id)}
                style={{ cursor: 'pointer' }}
              >
                <div className="blog-image-container">
                  {blog.images && blog.images.length > 0 ? (
                    <Card.Img
                      variant="top"
                      src={`https://madhusewingmachines.com/uploads/${blog.images[0].url}`}
                      alt={blog.title}
                      className="blog-image"
                    />
                  ) : (
                    <div className="no-image-placeholder">
                      <span>No Image</span>
                    </div>
                  )}
                </div>

                <Card.Body className="d-flex flex-column">
                  {blog.category && (
                    <Badge bg="info" className="align-self-start mb-2">
                      {blog.category}
                    </Badge>
                  )}
                  <Card.Title className="blog-title">{blog.title}</Card.Title>
                  <Card.Text className="blog-excerpt text-muted small flex-grow-1">
                    {getExcerpt(blog.content)}
                  </Card.Text>
                  <div className="blog-meta small text-muted mt-2 d-flex justify-content-between">
                    {blog.author && <span>By {blog.author}</span>}
                    <span>{formatDate(blog.createdAt)}</span>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default Blog;
